module.exports = __webpack_public_path__ + "img/biolink-fullbanner.04e6489.jpg";